import script from "./TitlePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePreview.vue?vue&type=script&setup=true&lang=js"

import "./TitlePreview.vue?vue&type=style&index=0&id=d9900540&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9900540"]])

export default __exports__